export enum SnackbarStatus {
  Error = 'error',
  Success = 'success',
  Warn = 'warn',
  Info = 'info',
}

